import { Typography } from '@mui/material'
import React from 'react'
import './Quotation.css'
import api from "../../components/services/api";
import { useParams } from 'react-router';
import { useState } from 'react';
import { useEffect } from 'react';
import moment from 'moment';
import 'moment/locale/th'  // without this line it didn't work
moment.locale('th')

export default function ContainerListLoading() {
    let { id } = useParams();
    const [data, setData] = useState()
    const getData = async () => {
        const res = await api(`api/train/detail/wagon/${id}`)
        const data = await res.data
        setData(data)
    }
    
    useEffect(() => {
        getData()
    }, [])

    // const pageCount = Math.ceil(data?.detail?.length / 6)

    // for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {

    //     console.log(data?.detail?.slice(pageIndex * 10, pageIndex * 10 + 10))
    // } 
    const pageCount = Math.ceil(data?.length / 10)
    const rows = [];
    for (let pageIndex = 0; pageIndex < pageCount; pageIndex++) {
        rows.push(<>
            <page>
                <div className="header">
                    <img src="/images/logo2.png" className="logo" />
                    <div className="header_title">
                        <h3 >SRITRANG LOGISTIC COMPANY LIMITED</h3>
                        <h6>56/4 Bannaiwang Rd, Tambol Pakphraek,Thung Song, Nakhon Si Thammarat, 80110</h6>
                        <h5 >บริษัท ศรีตรังโลจิสติกส์ จำกัด </h5>
                        <h6 >56/4 ถนนบ้านในหวัง ตำบลปากแพรก อำเภอ ทุ่งสง จังหวัด นครศรีธรรมราช 80110</h6>
                    </div>
                </div>
                <div className="content">
                    <div className="titleR" style={{ justifyContent: "end" }}>
                        <h6>วันที่ </h6>
                        <h6 style={{ marginLeft: '10px' }}>{moment().locale('th').add('year', 543).format('LL')} </h6>
                    </div>
                </div>
                <div className="content">
                    <div className="rowR" style={{ flexBasis: '100%' }}>
                        <p className='header_p' style={{ flexBasis: '10%' }}>เรื่อง </p>
                        <p > ขอแจ้งหมายเลขรถ บทต. และหมายเลขตู้ (คอนเทนเนอร์) ที่ขนส่งทางรถไฟ</p>
                    </div>

                    <div className="rowR" style={{ flexBasis: '100%' }}>
                        <p className='header_p' style={{ flexBasis: '10%' }}>เรียน</p>
                        <p>หัวหน้าหน่วยบริการรับส่งสินค้าสถานีรถไฟ.............................</p>
                    </div>

                    <div className="rowR" style={{ flexBasis: '100%' }}>
                        <p className='header_p' style={{ flexBasis: '10%' }}></p>
                        <p>ด้วยบริษัทฯ มีความประสงค์จะบรรทุกสินค้า (คอนเทนเนอร์) บรรจุทางรถไฟ จากสถานีรถไฟ............................. </p>
                    </div>

                    <div className="rowR" style={{ flexBasis: '100%' }}>
                        <p className='header_p' style={{ flexBasis: '10%' }}>ไปยัง</p>
                        <p> สถานีรถไฟ............................. มีรายละเอียดดังนี้</p>
                    </div>


                </div>

                <div className="containerR">
                    <table border="1" cellpadding="10" cellspacing="0" style={{ width: '95%' }}>
                        <tr style={{ border: '1px solid' }}>
                            <th style={{ border: '1px solid' }}>
                                ลำดับ
                            </th>
                            <th style={{ border: '1px solid' }}>
                                หมายเลข บทต.
                            </th>
                            <th style={{ border: '1px solid' }}>
                                หมายเลขตู้คอนเทนเนอร์
                            </th>
                            <th style={{ border: '1px solid' }}>
                                หมายเลขตู้คอนเทนเนอร์
                            </th>
                            <th style={{ border: '1px solid' }}>
                                ขนาดตู้ (ฟุต)
                            </th>
                            <th style={{ border: '1px solid' }}>
                                เปล่า/บรรทุก

                            </th>
                            <th style={{ border: '1px solid' }}>
                                น้ำหนักสินค้า+น้ำหนักตู้

                            </th>
                            <th style={{ border: '1px solid' }}>
                                Closing Date
                            </th>
                            <th style={{ border: '1px solid' }}>
                                Closing Time
                            </th>
                        </tr>

                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.No}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.WagonNo}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.ContainerNo_1}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.ContainerNo_2}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.Size}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.Commodity}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.VGMWeight}</td>
                            <td style={{ border: '1px solid' }}>{moment(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.ClosingDate).add('year', 543).format('DD/MM/YYYY')}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[0]?.ClosingTime}</td>
                        </tr>
                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.No}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.WagonNo}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.ContainerNo_1}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.ContainerNo_2}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.Size}</td>
                            <td style={{ border: '1px solid' }} >{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.Commodity}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.VGMWeight}</td>
                            <td style={{ border: '1px solid' }}>{moment(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.ClosingDate).add('year', 543).format('DD/MM/YYYY')}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[1]?.ClosingTime}</td>
                        </tr>
                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.No}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.WagonNo}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.ContainerNo_1}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.ContainerNo_2}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.Size}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.Commodity}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.VGMWeight}</td>
                            <td style={{ border: '1px solid' }}>{moment(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.ClosingDate).add('year', 543).format('DD/MM/YYYY')}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[2]?.ClosingTime}</td>
                        </tr>
                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.No}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.WagonNo}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.ContainerNo_1}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.ContainerNo_2}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.Size}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.Commodity}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.VGMWeight}</td>
                            <td style={{ border: '1px solid' }}>{moment(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.ClosingDate).add('year', 543).format('DD/MM/YYYY')}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[3]?.ClosingTime}</td>
                        </tr>
                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.No}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.WagonNo}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.ContainerNo_1}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.ContainerNo_2}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.Size}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.Commodity}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.VGMWeight}</td>
                            <td style={{ border: '1px solid' }}>{moment(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.ClosingDate).add('year', 543).format('DD/MM/YYYY')}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[4]?.ClosingTime}</td>
                        </tr>
                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.No}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.WagonNo}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.ContainerNo_1}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.ContainerNo_2}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.Size}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.Commodity}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.VGMWeight}</td>
                            <td style={{ border: '1px solid' }}>{moment(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.ClosingDate).add('year', 543).format('DD/MM/YYYY')}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[5]?.ClosingTime}</td>
                        </tr>
                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.No}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.WagonNo}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.ContainerNo_1}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.ContainerNo_2}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.Size}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.Commodity}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.VGMWeight}</td>
                            <td style={{ border: '1px solid' }}>{moment(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.ClosingDate).add('year', 543).format('DD/MM/YYYY')}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[6]?.ClosingTime}</td>
                        </tr>
                        {console.log(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.WagonNo)}
                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.No}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.WagonNo}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.ContainerNo_1}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.ContainerNo_2}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.Size}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.Commodity}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.VGMWeight}</td>
                            <td style={{ border: '1px solid' }}>{moment(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.ClosingDate).add('year', 543).format('DD/MM/YYYY')}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[7]?.ClosingTime}</td>
                        </tr>
                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.No}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.WagonNo}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.ContainerNo_1}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.ContainerNo_2}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.Size}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.Commodity}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.VGMWeight}</td>
                            <td style={{ border: '1px solid' }}>{moment(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.ClosingDate).add('year', 543).format('DD/MM/YYYY')}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[8]?.ClosingTime}</td>
                        </tr>
                        <tr style={{ border: '1px solid', fontSize: '16px', height: '27px' }}>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.No}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.WagonNo}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.ContainerNo_1}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.ContainerNo_2}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.Size}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.Commodity}</td>
                            <td style={{ border: '1px solid' }} align='center'>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.VGMWeight}</td>
                            <td style={{ border: '1px solid' }}>{moment(data?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.ClosingDate).add('year', 543).format('DD/MM/YYYY')}</td>
                            <td style={{ border: '1px solid' }}>{data?.slice(pageIndex * 10, pageIndex * 10 + 10)[9]?.ClosingTime}</td>
                        </tr>
                        


                    </table>
                </div>


                <div className="content_footer" style={{justifyContent:'end'}}>

                    <div className="rowR">
                        <p>ขอแสดงความนับถือ</p>
                        <p style={{ lineHeight: '24px' }}>______________________________</p>
                        <p>(.........................................................)</p>

                        <p>Date.............../.............../...............</p>
                    </div>
                </div>
                <div className="footerR">
                    <p>SRITRANG LOGISTIC COMPANY LIMITED
                    </p>
                    <p> F-MK-004 ฉบับแก้ไขครั้งที่ ..... วันที่อนุมัติใช้ ........./........../..........
                    </p>
                </div>

            </page>
            {/* <div style={{ pageBreakAfter: "always" }}></div> */}
        </>
        )
    }
    return (
        <>
            {rows}
        </>
    )
}
